import defaultAttributes from '../defaultAttributes';

const Divide = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '6', r: '1' }],
    ['line', { x1: '5', y1: '12', x2: '19', y2: '12' }],
    ['circle', { cx: '12', cy: '18', r: '1' }],
  ],
];

export default Divide;
